import { Box, useMediaQuery } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import ImageInput from "../../../components/imageInput";
import TextFieldCompnent from "../../../components/textFieldComponent";
import ButtonComponent from "../../../components/ButtonComponent";
import { useTranslation } from "react-i18next";

const CategoryForm = ({ buttonText, handleFormSubmit, initialValues, previewImage, setPreviewImage, loading,image }) => {
    const { t } = useTranslation();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const productSchema = yup.object().shape({
        name: yup.string().required("Nom est requis"),
    });

    return (
        <Formik
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={productSchema}
        >
            {({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
            }) => (
                <form onSubmit={handleSubmit}>
                    <Box
                        display="grid"
                        gap="16px"
                        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 6" },
                        }}
                    >
                        <TextFieldCompnent
                            type="text"
                            label={t("fields.name")}
                            change={handleChange}
                            value={values.name}
                            name="name"
                            blur={handleBlur}
                            touched={touched.name}
                            error={errors.name}
                            colum="span 3"
                            row="1 / span 1"
                            required
                        />
                        <ImageInput
                            row="2 / span 1"
                            previewImage={previewImage}
                            setPreviewImage={setPreviewImage}
                            image={image}
                            mediaTargetType="Category"
                        />
                    </Box>
                    <ButtonComponent text={buttonText} loading={loading} />
                </form>
            )}
        </Formik>
    );
};

export default CategoryForm;
